import { AddmissionContent } from "../../components/accounting";

export default function Addmission() {
  return <AddmissionContent />;
}
